import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export const useNavigationHelper = () => {
  const navigate = useNavigate();

  const goToCompetitions = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const goToCategories = useCallback(
    (competitionId: string) => {
      navigate(`/${competitionId}/categories`);
    },
    [navigate],
  );

  const goToRounds = useCallback(
    (competitionId: string, categoryId: string) => {
      navigate(`/${competitionId}/categories/${categoryId}/rounds`);
    },
    [navigate],
  );

  const goToResults = useCallback(
    (competitionId: string, categoryId: string, roundId: string) => {
      navigate(`/${competitionId}/categories/${categoryId}/rounds/${roundId}`);
    },
    [navigate],
  );

  const goToFinalResultsCategories = useCallback(
    (competitionId: string) => {
      navigate(`/${competitionId}/final-results`);
    },
    [navigate],
  );

  const goToFinalResults = useCallback(
    (competitionId: string, categoryId: string) => {
      navigate(`/${competitionId}/final-results/${categoryId}`);
    },
    [navigate],
  );

  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const goToSchedule = useCallback(
    (competitionId: string) => {
      navigate(`/${competitionId}/schedule`);
    },
    [navigate],
  );

  const goToScheduleList = useCallback(
    (competitionId: string) => {
      navigate(`/${competitionId}/schedule-list`);
    },
    [navigate],
  );

  const goToScheduleDay = useCallback(
    (competitionId: string, scheduleId: string) => {
      navigate(`/${competitionId}/schedule/${scheduleId}`);
    },
    [navigate],
  );

  const goToSchedulePosition = useCallback(
    (competitionId: string, scheduleId: string, positionId: string) => {
      navigate(`/${competitionId}/schedule/${scheduleId}/position/${positionId}`);
    },
    [navigate],
  );

  return {
    goToCompetitions,
    goToCategories,
    goToRounds,
    goToResults,
    goToFinalResultsCategories,
    goToFinalResults,
    goBack,
    goToSchedule,
    goToScheduleList,
    goToScheduleDay,
    goToSchedulePosition,
  };
};
